'use client'

import React from 'react'
import { AnalyticsService } from '@/lib/analytics'

export type AnalyticsContextType = {
    analytics: AnalyticsService
}

const analytics = new AnalyticsService()

const DefaultAnalyticsContext: AnalyticsContextType = {
    analytics,
}

export const AnalyticsContext = React.createContext(DefaultAnalyticsContext)
